import React from 'react';
import { FaCheck } from 'react-icons/fa';

interface IProps {
  title: string;
  features: string[];
  highlight?: boolean;
  description?: string;
  onClick: () => void;
  className?: string;
}

export const PlanCard = (props: IProps) => {
  const { title, features, highlight, description, onClick, className } = props;
  return (
    <div
      className={`flex flex-col justify-between bg-white rounded-2xl px-6 py-6 ${
        className || ""
      }`}
    >
      <div>
        {/* Plan Title */}
        <div
          className={`text-xl px-2 py-2 rounded-md mb-4 w-full font-medium ${
            highlight
              ? "border-2 border-[#f58220] bg-[#f58220] text-white"
              : "border-2 border-[#f58220] text-[#f58220] min-w-[440px] w-full"
          }`}
        >
          {title}
        </div>

        {/* Description */}
        {description && (
          <p className="text-m text-gray-800 mb-4">{description}</p>
        )}

        {/* Feature List */}
        <ul className="flex flex-col gap-3 text-m leading-relaxed text-[#111]">
          {features.map((feature, idx) => (
            <li key={idx} className="flex gap-2 items-start w-full">
              <div className="flex-shrink-0 pt-1">
                <FaCheck className="text-[#f58220]" />
              </div>
              <div className="flex-1">{feature}</div>
            </li>
          ))}
        </ul>
      </div>

      {/* Upgrade Button */}
      <button
        onClick={onClick}
        className="mt-6 bg-[#f58220] text-white px-5 py-2 rounded-md text-m font-medium w-fit"
      >
        Upgrade to {title}
      </button>

      {/* Previous Upgrade Button */}
      {/* <div className="mt-10 flex justify-center">
        <ZeosButton
          label={`Upgrade to ${title}`}
          mode={highlight ? "done" : "next"}
          onPress={onClick} type={"button"}        />
      </div> */}
      
    </div>
  );
}
